import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export default Steps;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/steps/index.js
// module id = 436
// module chunks = 0